export default __webpack_public_path__ + "static/media/Man-pointing-down.99c3242b.png";